import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { inputCls } from "@/lib/labels";

export const PasswordInput = ({ value, onChange, testId, autoComplete = "current-password", placeholder = "" }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} dir="ltr" autoComplete={autoComplete} value={value} onChange={onChange} placeholder={placeholder}
        className={`${inputCls} pl-12 text-right`} data-testid={testId} required />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "اخفي كلمة السر" : "اظهر كلمة السر"} data-testid={`${testId}-toggle`}
        className="absolute left-3 top-1/2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-full text-[var(--km-lilac)] hover:bg-white/10">
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="font-head mb-1.5 block text-sm font-bold text-white">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-purple-300/60">{hint}</span>}
  </label>
);
